/**
 * Emergency pause a market (resolver only)
 */
import type { Address, Hash, WalletClient } from "viem"
import { breakoutMarketAbi } from "../../abi/generated/breakoutMarket"
import { getAccount } from "../../internal/contracts"

export interface EmergencyPauseParams {
	market: Address
}

/**
 * Emergency pause a market
 *
 * Can only be called by the resolver. Pauses all trading immediately.
 * Use for critical issues like oracle manipulation or smart contract bugs.
 *
 * @example
 * ```ts
 * import { emergencyPause } from "@breakout/sdk/actions/write"
 *
 * const txHash = await emergencyPause(walletClient, { market: "0x..." })
 * ```
 */
export async function emergencyPause(
	client: WalletClient,
	params: EmergencyPauseParams,
): Promise<Hash> {
	const account = await getAccount(client)

	return client.writeContract({
		address: params.market,
		abi: breakoutMarketAbi,
		functionName: "emergencyPause",
		args: [],
		account,
		chain: client.chain,
	})
}
